import * as React from "react";
import {
  forwardRef,
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import * as throttle from "lodash.throttle";
import { TABLET } from "../constant/Breakpoints";

const Container = styled.section`
  overflow: hidden;
  padding: 48px;
`;

const Content = styled.div<{ visible: boolean }>`
  max-width: 1400px;
  margin: auto;
  padding: 48px 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: translateY(${({ visible }) => (visible ? 0 : 70)}px);
  transition: all 0.5s ease;

  @media screen and (max-width: ${TABLET}px) {
    padding: 48px 12px;
  }
`;

export const Section = forwardRef(
  (
    {
      children,
      noAnimation,
      ...props
    }: PropsWithChildren<
      React.HTMLAttributes<HTMLDivElement> & { noAnimation?: boolean }
    >,
    ref
  ) => {
    const [visible, setVisible] = useState(noAnimation);
    const container = useRef<HTMLDivElement>(null);
    const handleScroll = useCallback(
      throttle(() => {
        if (!container.current) {
          return;
        }

        const rect = container.current.getBoundingClientRect();
        setVisible(rect.top < window.innerHeight * 0.65);
      }, 200),
      [container, setVisible]
    );

    useEffect(() => {
      if (noAnimation) {
        return;
      }

      handleScroll();
      document.addEventListener("scroll", handleScroll);
      return () => {
        document.removeEventListener("scroll", handleScroll);
      };
    }, [handleScroll, noAnimation]);

    return (
      <Container ref={container} {...props}>
        <noscript style={{ maxWidth: 0 }}>
          <style
            dangerouslySetInnerHTML={{
              __html: `
            .no_script-show {
                opacity: 1;
                transform: translateY(0px);
            }
        `,
            }}
          />
        </noscript>
        <Content className="no_script-show" visible={visible} ref={ref}>
          {children}
        </Content>
      </Container>
    );
  }
);
